<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <div class="alert alert-danger" v-show="isError" v-html="errorMessage"></div>
</template>

<script>
import {errorMessage, isError} from '@/inc/storage';
export default {
  name: "ErrorBlock",
  setup(){
    return {
      errorMessage, isError
    }
  }
}
</script>

<style scoped>

</style>